import * as angular from 'angular';
import { getCityStateAndZipcode, getFullAddress, getStreetAddress } from 'common/source/utilities/policyInfoDisplay';
import { getOverviewSref } from 'components/navigation/shared/states';
import { getPolicyTermText } from '../../shared';
import { getMomentFromHippoDateString } from 'common/source/utilities/dates';

interface PoliciesPreviousPolicyCardController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;
    policyIndex: RoutePolicyIndex;

    policyNumber: string;
    policyTerm: string;

    streetAddress: string;
    cityStateAndZipcode: string;
    fullAddress: string;

    overviewSref: string;
    showPolicyTerm: boolean;
}

export function policiesPreviousPolicyCardController(
    this: PoliciesPreviousPolicyCardController,
    $element: angular.IAugmentedJQuery
) {
    'ngInject';

    this.$onInit = () => {
        this.policyNumber = this.policyInfo.policy_number;

        const effectiveDateMoment = getMomentFromHippoDateString(this.policyInfo.effective_date);
        const expirationDateMoment = getMomentFromHippoDateString(this.policyInfo.expiration_date);

        if (expirationDateMoment.isSameOrBefore(effectiveDateMoment)) {
            // expired before policy became active
            this.showPolicyTerm = false;
        } else {
            this.showPolicyTerm = true;
        }

        this.policyTerm = getPolicyTermText(this.policyInfo);

        this.streetAddress = getStreetAddress(this.policyInfo);
        this.fullAddress = getFullAddress(this.policyInfo);
        this.cityStateAndZipcode = getCityStateAndZipcode(this.policyInfo);

        this.overviewSref = getOverviewSref(this.policyIndex);
    };
}
